import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import TextInput from '../../components/FormElements/TextInput';
import Logo from '../../components/Branding/Logo'; // Import the Logo component
// import './NewPasswordScreen.css'; // Ensure this file exists or styles are globally available

function NewPasswordScreen() {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const role = searchParams.get('role') || 'user';

    useEffect(() => {
        if (!token) {
            setMessage('Enlace inválido o token no encontrado. Solicita un nuevo restablecimiento de contraseña.');
        }
    }, [token]);

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        }
        if (message) setMessage('');
    };

    const toggleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setMessage('');
        let currentErrors = {};

        if (!formData.newPassword) {
            currentErrors.newPassword = 'La nueva contraseña es requerida.';
        } else if (formData.newPassword.length < 8) { // Example: min length validation
            currentErrors.newPassword = 'La contraseña debe tener al menos 8 caracteres.';
        }

        if (!formData.confirmPassword) {
            currentErrors.confirmPassword = 'Debes confirmar la nueva contraseña.';
        } else if (formData.newPassword && formData.newPassword !== formData.confirmPassword) {
            currentErrors.confirmPassword = 'Las contraseñas no coinciden.';
        }

        if (Object.keys(currentErrors).length > 0) {
            setErrors(currentErrors);
            return;
        }

        setIsLoading(true);
        console.log('Setting new password for role:', role, 'token:', token);
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
        try {
            const response = await fetch(`${API_BASE}/api/${role}s/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    password: formData.newPassword
                }),
            });

            if (!response.ok) {
                const data = await response.json().catch(() => ({}));
                throw new Error(data.message || 'Error en la solicitud');
            }

            const data = await response.json();
            setMessage(data.message || 'Contraseña restablecida exitosamente.');
            setFormData({ newPassword: '', confirmPassword: '' });
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            console.error('Reset password error:', error);
            setMessage(error.message || 'Error al restablecer la contraseña. Verifica el token e inténtalo de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="col-md-7 col-lg-7 col-xl-7 mx-auto d-flex justify-content-center align-items-center">
            <div className="form-container text-center">
                <Logo /> {/* Using the imported Logo component */}

                <h2 className="text-center mb-2">Establecer Nueva Contraseña</h2>
                <p className="text-muted mb-4">
                    Por favor, ingresa y confirma tu nueva contraseña a continuación.
                </p>

                {message && (
                    <div className={`alert ${message.startsWith('Error') ? 'alert-danger' : 'alert-success'} mb-3`} role="alert">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="checkin-form text-start">
                    <TextInput
                        label="Nueva Contraseña"
                        type={showNewPassword ? 'text' : 'password'}
                        id="newPassword"
                        name="newPassword"
                        value={formData.newPassword}
                        onChange={handleChange}
                        required
                        error={errors.newPassword}
                        iconClass={`bi ${showNewPassword ? 'bi-eye' : 'bi-eye-slash'}`}
                        onIconClick={toggleNewPasswordVisibility}
                        iconAriaLabel="Mostrar u ocultar nueva contraseña"
                    />
                    <TextInput
                        label="Confirmar Nueva Contraseña"
                        type={showConfirmPassword ? 'text' : 'password'}
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        error={errors.confirmPassword}
                        iconClass={`bi ${showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'}`}
                        onIconClick={toggleConfirmPasswordVisibility}
                        iconAriaLabel="Mostrar u ocultar confirmación de contraseña"
                    />
                    <button type="submit" className="btn btn-checkin w-100 mt-4" disabled={isLoading}>
                        {isLoading ? 'Estableciendo...' : 'Establecer Contraseña'}
                    </button>
                </form>
                <div className="text-center mt-3">
                    <Link to="/" className="text-decoration-none" style={{ color: 'var(--color-texto-secundario)' }}>Volver al inicio</Link>
                </div>
            </div>
        </div>
    );
}

export default NewPasswordScreen;